(function () {
  'use strict';
  var STARTER = '5.75LB Pair';
  var LOAD_WEIGHT = {
    '5.75LB Pair': '14 lb',
    '8.75LB Pair': '20 lb',
    '14.5LB Pair': '31 lb',
    '19.75LB Pair': '42 lb'
  };
  var PLATE_ID_TO_BUNDLE = {
    '41314968338532': 44026483146852,
    '41314968371300': 44026483179620,
    '41314968404068': 44026483212388,
    '41314968436836': 44026483245156
  };
  var cfg = window.__wolfBundleTreatmentFix;
  if (!cfg || cfg.handle !== 'vest-and-weight') return;

  var landingVariant = window.__wolfBundleLandingVariant;
  if (landingVariant === undefined) {
    landingVariant = new URLSearchParams(location.search).get('variant');
  }

  function variantMap() {
    return cfg.variants || {};
  }

  function variantById(id) {
    var map = variantMap();
    var want = String(id);
    for (var key in map) {
      if (String(map[key].id) === want) return { key: key, variant: map[key] };
    }
    return null;
  }

  if (landingVariant && PLATE_ID_TO_BUNDLE[String(landingVariant)]) {
    var mapped = String(PLATE_ID_TO_BUNDLE[String(landingVariant)]);
    if (variantById(mapped)) {
      var nextUrl = new URL(location.href);
      nextUrl.searchParams.set('variant', mapped);
      location.replace(nextUrl.pathname + nextUrl.search + nextUrl.hash);
      return;
    }
  }

  var patched = typeof WeakSet === 'function' ? new WeakSet() : null;
  var adding = false;
  var locked = false;
  var restoring = typeof WeakSet === 'function' ? new WeakSet() : null;
  var userTouched = false;
  var clickBound = false;

  function variantKey(color, load) {
    return String(color) + '|' + String(load);
  }

  function liveVariant(color, load) {
    var map = variantMap();
    var exact = map[variantKey(color, load)];
    if (exact) return exact;
    var want = variantKey(String(color).toLowerCase(), String(load).toLowerCase());
    for (var key in map) {
      if (String(key).toLowerCase() === want) return map[key];
    }
    return null;
  }

  function selectedColor(root) {
    var pressed = root.querySelector('[data-color][aria-pressed="true"]');
    return pressed ? pressed.getAttribute('data-color') : null;
  }

  function selectedLoad(root) {
    var pressed = root.querySelector('[data-load][aria-pressed="true"]');
    return pressed ? pressed.getAttribute('data-load') : null;
  }

  function money(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function eachOverlay(fn) {
    var nodes = document.querySelectorAll('#wt-pdp-bundle');
    var i;
    for (i = 0; i < nodes.length; i++) fn(nodes[i]);
  }

  function liveRoot() {
    var nodes = document.querySelectorAll('#wt-pdp-bundle');
    if (!nodes.length) return null;
    return nodes[nodes.length - 1];
  }

  function setStatus(root, message) {
    var next = message || '';
    function write(node) {
      var status = node.querySelector('[data-status]');
      if (status && status.textContent !== next) status.textContent = next;
    }
    if (root) write(root);
    else eachOverlay(write);
  }

  function setBusy(root, busy) {
    var want = !!busy;
    function write(node) {
      var buttons = node.querySelectorAll('[data-atc]');
      var i;
      for (i = 0; i < buttons.length; i++) {
        if (buttons[i].disabled !== want) buttons[i].disabled = want;
        if (want) {
          if (buttons[i].getAttribute('aria-busy') !== 'true') buttons[i].setAttribute('aria-busy', 'true');
        } else if (buttons[i].hasAttribute('aria-busy')) {
          buttons[i].removeAttribute('aria-busy');
        }
      }
    }
    if (root) write(root);
    else eachOverlay(write);
  }

  function rewriteProof(root) {
    var hero = root.querySelector('.wt-hero-proof');
    if (hero) {
      hero.setAttribute('aria-label', '96% of reviewers recommend Wolf');
      hero.innerHTML = '<strong>96%</strong><span>of reviewers recommend Wolf</span><span class="wt-hero-proof__award"><strong>Men\'s Health</strong> · Best Full-Sized Plate Carrier</span>';
    }
    var rating = root.querySelector('.wt-rating');
    if (rating) {
      rating.setAttribute('aria-label', '96% of reviewers recommend Wolf');
      rating.innerHTML = '<strong>96%</strong><div><span>of reviewers recommend Wolf</span></div>';
    }
    var specs = root.querySelectorAll('.wt-spec');
    for (var i = 0; i < specs.length; i++) {
      var copy = ((specs[i].querySelector('.wt-spec__copy') || {}).textContent || '') +
        ((specs[i].querySelector('.wt-spec__name') || {}).textContent || '');
      if (!/customer|community|counting/i.test(copy)) continue;
      var num = specs[i].querySelector('.wt-spec__num');
      if (num && /35,?000/.test(num.textContent || '')) {
        num.textContent = '4.6';
        var name = specs[i].querySelector('.wt-spec__name');
        var body = specs[i].querySelector('.wt-spec__copy');
        if (name) name.textContent = 'Reviews.io company reviews';
        if (body) body.textContent = 'The same company rating shown on the Wolf product page.';
      }
    }
  }

  function removeDeadSwatches(root) {
    var colors = root.querySelectorAll('[data-color]');
    for (var i = 0; i < colors.length; i++) {
      var name = colors[i].getAttribute('data-color') || '';
      if (/camo/i.test(name) || !liveVariant(name, STARTER)) {
        if (colors[i].parentNode) colors[i].parentNode.removeChild(colors[i]);
      }
    }
  }

  function markStarterPopular(root) {
    var buttons = root.querySelectorAll('[data-load]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var pop = btn.querySelector('.wt-load__popular');
      var isStarter = btn.getAttribute('data-load') === STARTER;
      if (isStarter && !pop) {
        var title = btn.querySelector('.wt-load__title');
        if (title) {
          pop = document.createElement('span');
          pop.className = 'wt-load__popular';
          pop.textContent = 'Most popular';
          title.appendChild(pop);
        }
      } else if (!isStarter && pop && pop.parentNode) {
        pop.parentNode.removeChild(pop);
      }
    }
    var ladder = root.querySelectorAll('[data-ladder] .wt-tier');
    for (var j = 0; j < ladder.length; j++) {
      var kicker = ladder[j].querySelector('.wt-tier__kicker');
      if (!kicker) continue;
      var stripped = String(kicker.textContent || '').replace(/\s*·\s*Most popular/i, '');
      var next = /starter/i.test(stripped) ? stripped.replace(/\s*$/, '') + ' · Most popular' : stripped;
      if (kicker.textContent !== next) kicker.textContent = next;
    }
  }

  function landingIntent() {
    if (!landingVariant) return null;
    var found = variantById(landingVariant);
    if (found && found.key) {
      var parts = found.key.split('|');
      return { color: parts[0], load: parts.slice(1).join('|') };
    }
    for (var plateId in PLATE_ID_TO_BUNDLE) {
      if (plateId === String(landingVariant)) {
        var mappedVar = variantById(PLATE_ID_TO_BUNDLE[plateId]);
        if (mappedVar && mappedVar.key) {
          var mappedParts = mappedVar.key.split('|');
          return { color: mappedParts[0], load: mappedParts.slice(1).join('|') };
        }
      }
    }
    return null;
  }

  function clickAttr(root, attr, value) {
    if (!value) return;
    var escaped = (window.CSS && CSS.escape) ? CSS.escape(value) : String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    var match = root.querySelector('[' + attr + '="' + escaped + '"]');
    if (match) match.click();
  }

  function applyLandingOrStarter(root) {
    if (userTouched) return;
    if (restoring && restoring.has(root)) return;
    if (restoring) restoring.add(root);
    var intent = landingIntent();
    setBusy(root, true);
    var tries = 0;
    function done() {
      if (restoring) restoring.delete(root);
      if (!adding && !locked) setBusy(root, false);
    }
    function step() {
      if (userTouched) {
        done();
        return;
      }
      var wantColor = intent && intent.color;
      var wantLoad = (intent && intent.load) || STARTER;
      if (wantColor && selectedColor(root) !== wantColor) clickAttr(root, 'data-color', wantColor);
      if (selectedLoad(root) !== wantLoad) clickAttr(root, 'data-load', wantLoad);
      markStarterPopular(root);
      var colorOk = !wantColor || selectedColor(root) === wantColor;
      var loadOk = selectedLoad(root) === wantLoad;
      tries += 1;
      if (colorOk && loadOk) {
        done();
        return;
      }
      if (tries < 8) window.setTimeout(step, 200);
      else {
        done();
        if (!userTouched) setStatus(root, 'We could not restore that bundle selection. Choose a load, then add to cart.');
      }
    }
    step();
  }

  function emitAddToCart(line, done) {
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      if (timer) window.clearTimeout(timer);
      done();
    }
    var timer = window.setTimeout(finish, 1200);
    var ec = {
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
      value: Number(line.price || 0) / 100,
      items: [{
        item_id: String(line.id || ''),
        item_name: String(cfg.title || 'Weighted Vest & Plate Bundle'),
        item_variant: String(line.title || ''),
        price: Number(line.price || 0) / 100,
        quantity: 1
      }]
    };
    try {
      var form = document.querySelector('form[action*="/cart/add"]') || document.body;
      form.dispatchEvent(new CustomEvent('theme:add_to_cart', { detail: { ecommerce: ec, source: 'bundle-treatment' }, bubbles: true, composed: true }));
    } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', 'add_to_cart'); } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: 'add_to_cart', ecommerce: ec, eventCallback: finish, eventTimeout: 1200 });
    } catch (e) {
      finish();
    }
  }

  function openCart(payload) {
    function unlock() {
      adding = false;
      locked = false;
      setBusy(null, false);
    }
    function fallback() {
      unlock();
      window.location.assign('/cart');
    }
    try {
      if (typeof window.wolfOpenConfirmedCart === 'function') {
        window.wolfOpenConfirmedCart(payload, unlock, fallback);
        return;
      }
    } catch (e) {
      fallback();
      return;
    }
    fallback();
  }

  function addSelected(root, button) {
    if (adding || locked || (restoring && restoring.has(root))) return;
    var color = selectedColor(root);
    var load = selectedLoad(root);
    var variant = color && load ? liveVariant(color, load) : null;
    if (!variant || !variant.available || !variant.id) {
      setStatus(root, 'That combination is not available. Choose a color and load, then try again.');
      return;
    }
    adding = true;
    locked = false;
    setBusy(root, true);
    setStatus(root, '');
    var properties = { 'Total training weight': LOAD_WEIGHT[load] || load };
    var savings = (variant.compare_at_price > variant.price) ? (variant.compare_at_price - variant.price) : 0;
    if (savings > 0) properties['Bundle savings'] = money(savings);

    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    if (ctl) window.setTimeout(function () { try { ctl.abort(); } catch (e) {} }, 12000);

    var request;
    try {
      request = fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        signal: ctl && ctl.signal,
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties: properties }] })
      });
    } catch (e) {
      locked = true;
      setStatus(null, 'We could not confirm whether this item was added. Reload the page to try again.');
      return;
    }

    request.then(function (response) {
      if (response.ok) {
        return response.json().then(function (payload) {
          var rows = payload && payload.items ? payload.items : (payload ? [payload] : []);
          var item = null;
          var want = Number(variant.id);
          for (var i = 0; i < rows.length; i++) {
            if (Number(rows[i].variant_id || rows[i].id) === want) { item = rows[i]; break; }
          }
          if (!item) {
            var miss = new Error('Cart response did not include the added variant');
            miss.retrySafe = false;
            throw miss;
          }
          var charged = {
            id: item.variant_id || item.id,
            title: item.variant_title || item.title || variant.title,
            price: item.final_price != null ? item.final_price : (item.price != null ? item.price : variant.price)
          };
          emitAddToCart(charged, function () { openCart(payload); });
        });
      }
      var retrySafe = response.status >= 400 && response.status < 500;
      var err = new Error('Cart request failed');
      err.retrySafe = retrySafe;
      throw err;
    }).catch(function (err) {
      if (err && err.retrySafe) {
        adding = false;
        locked = false;
        setBusy(null, false);
        setStatus(null, 'This item could not be added. It may be sold out or unavailable.');
        return;
      }
      locked = true;
      setStatus(null, 'We could not confirm whether this item was added. Reload the page to try again.');
    });
  }

  function onClick(event) {
    var host = event.target && event.target.closest && event.target.closest('#wt-pdp-bundle');
    if (!host) return;
    if (event.isTrusted && event.target.closest('[data-color], [data-load]')) {
      userTouched = true;
    }
    var button = event.target.closest('[data-atc]');
    if (!button || !host.contains(button)) return;
    var root = host;
    if (button.disabled || adding || locked || (restoring && restoring.has(root))) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    addSelected(root, button);
  }

  function apply(root) {
    if (!root) return;
    if (patched) {
      if (patched.has(root)) return;
      patched.add(root);
    } else if (root.getAttribute('data-wolf-treatment-fix') === 'applied') {
      return;
    }
    root.setAttribute('data-wolf-treatment-fix', 'applied');
    removeDeadSwatches(root);
    rewriteProof(root);
    markStarterPopular(root);
    applyLandingOrStarter(root);
    if (!clickBound) {
      clickBound = true;
      document.addEventListener('click', onClick, true);
    }
  }

  function boot() {
    var main = document.getElementById('MainContent') || document.body;
    if (!main) return;
    var observer = null;
    function scan() {
      eachOverlay(function (found) {
        apply(found);
        if (adding || locked || (restoring && restoring.has(found))) setBusy(found, true);
        if (locked) setStatus(found, 'We could not confirm whether this item was added. Reload the page to try again.');
        markStarterPopular(found);
      });
    }
    scan();
    if (typeof MutationObserver !== 'function') return;
    observer = new MutationObserver(scan);
    observer.observe(main, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());
